import { loadResourcesUtils } from '@ane/core/lib/utils/LoadResourcesUtils';
import { getDefaultAsyncWrapperObj } from '@ane/core/lib/models';
import WPSResource from '../../../WPS.resource';
import { ROOT_REDUCER_KEYS, GLOBAL_ACTION_KEYS } from '../../workspaceSettingsReducer';
export const defaultReducerState = getDefaultAsyncWrapperObj();
const workspaceSecurityGroupsGetPrefix = 'WorkspaceSecurityGroupsGet';
const workspaceSecurityGroupsGetEpicReducerArg = {
    actionPrefix: workspaceSecurityGroupsGetPrefix,
    reduxKeyNested: (inputPayload) => [ROOT_REDUCER_KEYS.GLOBAL, GLOBAL_ACTION_KEYS.GET_SG],
    loadResource: (request) => {
        return WPSResource.getSecurityGroups(request.workspaceId, request.keyValue);
    },
    onCompleteSuccess: (resourcesResult) => resourcesResult,
};
export const workspaceSecurityGroupsGetEpicReducer = loadResourcesUtils(workspaceSecurityGroupsGetEpicReducerArg);

//# sourceMappingURL=GetWorkspaceSGs.ducks.js.map
